import CabinetMinisters from "./CabinetMinisters";

export default CabinetMinisters